import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "google-map__info-window" }
const _hoisted_2 = { class: "google-map__info-window__image-container" }
const _hoisted_3 = { class: "google-map__info-window__info" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "google-map__info-window__info__sub-header"
}
const _hoisted_6 = ["href"]

import TressResponsivePicture from "@/components/TressResponsivePicture.vue";
import dictionary from "@/i18n/dictionary.json";
import type { IResponsiveImagesModel } from "@/models/IResponsiveImagesModel";
import { computed, PropType, ref } from "vue";
import { GoogleMap, InfoWindow, Marker, MarkerCluster } from "vue3-google-map";

type MarkerModel = {
  name: string;
  coordinate: {
    lat: number;
    lng: number;
  };
  squareImage: IResponsiveImagesModel;
  url: string;
  address: string | null;
};

type MarkerCenter = {
  lng: number;
  lat: number;
};

type InfoWindowRef = InstanceType<typeof InfoWindow>;
type InfoWindowType = InfoWindowRef["infoWindow"];


export default /*#__PURE__*/_defineComponent({
  __name: 'TressGoogleMap',
  props: {
  center: {
    type: Object as PropType<MarkerCenter>,
    required: true,
  },
  markers: {
    type: Object as PropType<MarkerModel[]>,
    required: true,
  },
  zoom: {
    type: Number,
    required: true,
  },
  apiKey: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const props = __props;


const infowindows = ref<InfoWindowRef[]>([]);
const currentOpenInfoWindowIndex = ref<number | null>(null);

function closeInfoWindow(infoWindow: InfoWindowType | undefined) {
  infoWindow?.close();
  infoWindow?.set("anchor", null);
}

/**
 * Currently when the open info window is scrolled of the map the info window will disappear and not react to any calls to the function `infoWindow.close` as done in {@link closeInfoWindow}. This creates a bug where multiple info windows can be opened at the same time. This function checks if the info window that is trying to be opened is the current open one, if not it will close it.
 */
function closeIfNotCurrentOpen(index: number) {
  if (currentOpenInfoWindowIndex.value !== index) {
    closeInfoWindow(infowindows.value[index].infoWindow);
  }
}

function openInfoWindow(index: number) {
  for (const iw of infowindows.value) {
    closeInfoWindow(iw.infoWindow);
  }
  currentOpenInfoWindowIndex.value = index;
  infowindows.value[index].infoWindow?.open();
}

const markersWithCoordinates = computed(() =>
  props.markers.filter((x) => x.coordinate != null && !isNaN(x.coordinate.lat) && !isNaN(x.coordinate.lng))
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(GoogleMap), {
    "api-key": __props.apiKey,
    center: __props.center,
    "disable-default-ui": true,
    draggable: true,
    zoom: __props.zoom,
    "zoom-control": true,
    class: "google-map",
    style: {"width":"100%","height":"100%","position":"relative"}
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(MarkerCluster), null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markersWithCoordinates.value, (marker, index) => {
            return (_openBlock(), _createBlock(_unref(Marker), {
              key: `${marker.name}-${index}`,
              onClick: ($event: any) => (openInfoWindow(index)),
              options: { position: marker.coordinate }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(InfoWindow), {
                  ref_for: true,
                  ref_key: "infowindows",
                  ref: infowindows,
                  onVisible: ($event: any) => (closeIfNotCurrentOpen(index))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(TressResponsivePicture, {
                          pictures: marker.squareImage,
                          class: "google-map__info-window__img"
                        }, null, 8, ["pictures"])
                      ]),
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["google-map__info-window__info__header", { 'google-map__info-window__info__header--has-sub-header': marker.address }]),
                          innerHTML: marker.name
                        }, null, 10, _hoisted_4),
                        (marker.address)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(marker.address), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("a", {
                          href: marker.url,
                          class: "button button--default-denary move-to-top google-map__info-window__link",
                          type: "button"
                        }, _toDisplayString(_ctx.$t(_unref(dictionary).caseOverview.readMore)), 9, _hoisted_6)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["onVisible"])
              ]),
              _: 2
            }, 1032, ["onClick", "options"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["api-key", "center", "zoom"]))
}
}

})